var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBadge)?_c('div',{staticClass:"tag alert-badge card__tag",class:_vm.alert.completedMeasurement},[_vm._v(_vm._s(_vm.alertName))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }